<div class="container-fluid">
  <div class="row mt-3 public-calendar-header">
    <div class="col" *ngIf="!careTypeId">
      <form [formGroup]="careTypeForm">
        <select
          formControlName="careTypeId"
          class="form-select form-select-lg mb-3"
          aria-label=".form-select-lg">
          <option *ngFor="let careType of careTypes" value="{{ careType.id }}">
            {{ careType.name }}
          </option>
        </select>
      </form>
    </div>
    <div class="col">
      <h1 class="display-6 text-center">{{ community?.name }}</h1>
      <h4 class="text-center">{{ monthDay }}</h4>
    </div>
    <div class="col text-end">
      <img
        [src]="logo"
        alt="{{ community?.name }}"
        class="img-thumbnail img-logo" />
    </div>
  </div>

  <div class="row">
    <div class="col public-calendar">
      <full-calendar #calendar [options]="calendarOptions"></full-calendar>
    </div>
  </div>
</div>
